import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { SECTIONS } from "@/features/identity/sections";
import { EditorFormSection, EditorLinksSection, EditorMediaSection } from "@/features/identity/components/EditorSections";
import { ROUTES } from "@/constants/routes";

export default function ProfileEditorPage() {
  return (
    <div data-testid="profile-editor-page" className="mw-rise space-y-8">
      <header className="mb-4">
        <Link to={ROUTES.settings} data-testid="editor-back-link" className="inline-flex min-h-[44px] items-center gap-2 text-sm text-muted-foreground transition-colors hover:text-foreground">
          <ArrowLeft className="h-4 w-4" /> Settings
        </Link>
        <h1 className="mt-2 font-serif text-4xl tracking-tight sm:text-5xl">Professional identity.</h1>
        <p className="mt-3 max-w-xl text-sm leading-relaxed text-muted-foreground sm:text-base">
          The single source your card, public profile and signature will draw from. Each section saves on its own.
        </p>
      </header>
      <EditorFormSection section={SECTIONS.identity} />
      <EditorFormSection section={SECTIONS.contact} />
      <EditorFormSection section={SECTIONS.about} />
      <EditorLinksSection />
      <EditorMediaSection />
    </div>
  );
}
